import type { IconData } from '@stacksjs/iconify-core'

export const iFireExtinguisher: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M39.654 5.249v1.732h-7.489v-2.72H30C30 2.569 28.161.399 25.549.399c-2.543 0-4.847 1.986-4.847 4.982c0 1.424.818 2.696 1.54 3.129c-2.861 1.056-6.697 4.68-7.454 6.887c-1.053 2.104 1.837 3.868 3.323 1.764s3.152-4.685 8.102-5.923l.008 2.18c-2.041.386-7.663 3.7-7.663 10.135v37.396c0 .928.433 2.474 2.289 2.474h16.471c1.857 0 2.29-1.546 2.29-2.474V23.553c0-6.435-5.423-9.748-7.489-10.135l.01-2.601h7.526v1.61l18.416 2.784V2.571zM25.48 7.248a2.134 2.134 0 1 1 0-4.268a2.134 2.134 0 0 1 0 4.268\"/>",
  "width": 63,
  "height": 64,
  "viewBox": "0 0 63 64"
}

export default iFireExtinguisher
